/** Keys that do not require an active dossier edit lock for admin PUT /medical-partners/:id (must match API). */
const ADMIN_PUT_LOCK_EXEMPT_KEYS = new Set([
  "tcApprovalStatus",
  "tcApprovalNote",
  "tcApprovalUpdatedAt",
  "status",
]);

export function medicalPartnerPutNeedsLockBody(body) {
  if (!body || typeof body !== "object") return false;
  return Object.keys(body).some(
    (k) =>
      Object.prototype.hasOwnProperty.call(body, k) &&
      !ADMIN_PUT_LOCK_EXEMPT_KEYS.has(k)
  );
}

/**
 * @param {string|null|undefined} lockToken
 * @param {Record<string, unknown>} body
 * @param {import('axios').AxiosRequestConfig} [baseConfig]
 * @returns {import('axios').AxiosRequestConfig}
 */
export function medicalPartnerPutConfig(lockToken, body, baseConfig = {}) {
  if (!lockToken || !medicalPartnerPutNeedsLockBody(body)) {
    return baseConfig;
  }
  return {
    ...baseConfig,
    headers: {
      ...(baseConfig.headers || {}),
      "X-Partner-Edit-Lock": lockToken,
    },
  };
}
